import NursingAreaButtons from './NursingAreaButtons';

export default NursingAreaButtons;
